import { OffersClickoutGuard as e } from "../offers-clickout/index.js";
import { Component as t, Suspense as n } from "react";
import { jsx as r } from "react/jsx-runtime";
import { useTranslation as i } from "react-i18next";
import a from "@cx-modules/offers-slim";
//#region page-template/OffersSlim/OffersSlim.tsx
var o = class extends t {
	state = { hasError: !1 };
	static getDerivedStateFromError() {
		return { hasError: !0 };
	}
	componentDidCatch(e) {
		this.props.onError?.(e);
	}
	render() {
		return this.state.hasError ? null : this.props.children;
	}
}, s = ({ onError: t, ...s }) => {
	let { i18n: c } = i(), l = {
		...s,
		i18n: c
	};
	return /* @__PURE__ */ r(o, {
		onError: t,
		children: /* @__PURE__ */ r(n, {
			fallback: null,
			children: /* @__PURE__ */ r(e, {
				componentName: "OffersSlim",
				values: l,
				children: /* @__PURE__ */ r(a, { ...l })
			})
		})
	});
}, c = ({ autoHideTerms: e, geoTargeting: t, ocApiKey: n, repub: r, subdivision: i, ...a }) => ({
	...a,
	apiKey: n,
	variant: e ? "autohide" : "default",
	subdivisionCode: i,
	repub: r,
	geoTargeting: t,
	inheritFontFamily: !0,
	...t === !1 ? {
		countryCode: void 0,
		subdivisionCode: void 0
	} : {}
});
//#endregion
export { s as OffersSlim, c as OffersSlimContentContractForPageTemplate };
